const Config = {
    TOKEN: "token",
    CODE: "code",
    PERSONTYPECODE: "PERSONTYPECODE",
    NAME: "name",
};
export default Config;
  